

import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  TemplateRef,
  ViewEncapsulation
} from '@angular/core';

import { badgePresetColors } from './preset-colors';

@Component({
  selector: 'mwc-ribbon',
  exportAs: 'mwcRibbon',
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <ng-content></ng-content>
    <div
      class="mwc-ribbon"
      [class]="presetColor && 'mwc-ribbon-color-' + presetColor"
      [class.mwc-ribbon-placement-end]="mwcPlacement === 'end'"
      [class.mwc-ribbon-placement-start]="mwcPlacement === 'start'"
      [style.background-color]="!presetColor && mwcColor"
    >
      <ng-container *mwcStringTemplateOutlet="mwcText">
        <span class="mwc-ribbon-text">{{ mwcText }}</span>
      </ng-container>
      <div class="mwc-ribbon-corner" [style.color]="!presetColor && mwcColor"></div>
    </div>
  `,
  host: { class: 'mwc-ribbon-wrapper' }
})
export class MwcRibbonComponent implements OnChanges {
  @Input() mwcColor: string | undefined;
  @Input() mwcPlacement: 'start' | 'end' = 'end';
  @Input() mwcText: string | TemplateRef<void> | null = null;
  presetColor: string | null = null;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    const { mwcColor } = changes;
    if (mwcColor) {
      this.presetColor = this.mwcColor && badgePresetColors.indexOf(this.mwcColor) !== -1 ? this.mwcColor : null;
    }
  }
}
